import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import moment from 'moment';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';
import VueResource from 'vue-resource';

import App from './App.vue';
import MultiFiltersPlugin from './plugins/MultiFilters';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

Vue.prototype.moment = moment;
Vue.use(VueToastr);
Vue.use(VueResource);
Vue.use(MultiFiltersPlugin);

Vue.config.productionTip = false;
Vue.config.keyCodes.tab = 112;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
